import styles from "./index.module.scss";
import cn from "classnames";
import { ChangeEvent } from "react";

interface IInputProps {
  name: string;
  value: string;
  placeholder: string;
  readOnly?: boolean;
  // eslint-disable-next-line no-unused-vars
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  className?: string;
}
export default function RegularInput({
  className = "",
  ...rest
}: IInputProps): JSX.Element {
  const inputClasses: string = cn(styles.input, className);
  return (
    <div className={inputClasses}>
      <input type="text" {...rest} />
    </div>
  );
}
